import React, { lazy, Suspense } from 'react';
import {connect} from 'react-redux';
import {
  BrowserRouter as Router,
  Redirect,
  withRouter,
  Route
} from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { hasAnyRoleExist, hasAnyRoleNotExist, setPanelHeight } from "../actions/utils";
import { removeAllCache } from "../actions/actions";
const ClientList = lazy(() => import('../pages/XIVodafone/Client/list'));
const QueryList = lazy(() => import('../pages/XIVodafone/Query/list'));
const QueryCreate = lazy(() => import('../pages/XIVodafone/Query/create'));
const QuerySend = lazy(() => import('../pages/XIVodafone/Query/send'));
const QuerySendSuccess = lazy(() => import('../pages/XIVodafone/Query/success'));
const Report = lazy(() => import('../pages/XIVodafone/Report/list'));
const PartnerReport = lazy(() => import('../pages/XIVodafone/PartnerReport/list'));
const SmsApproveList = lazy(() => import('../pages/XIVodafone/Approve/list'));
const DraftList = lazy(() => import('../pages/XIVodafone/Draft/list'));

const renderLoader = () => <p>Loading</p>;
class XIVodafoneLayout extends React.Component {
    constructor(props){
        super(props);
    }

    componentDidMount() {
        setPanelHeight();
        window.addEventListener('load', setPanelHeight);
        window.addEventListener('resize', setPanelHeight);
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', setPanelHeight);
    }

    componentDidUpdate(prevProps, prevState, snapshot)
    {
        setPanelHeight();
    }

    render() {
        if(localStorage.getItem('user') == null || (hasAnyRoleExist(["XIVodafone"]) === false && hasAnyRoleExist("XIPartner") === false && hasAnyRoleExist("XIVFAdmin") === false) && hasAnyRoleExist("XIConsultant") === false)
        {
            localStorage.removeItem('user');
            localStorage.removeItem('userType');
            this.props.dispatch(removeAllCache());
            return (<Redirect
                        to={{
                            pathname: "/",
                            state: { from: this.props.location }
                        }}
                    />
              );
        }

        return (
            <div>
                <Suspense fallback={renderLoader()}>
                    <Header />
                    <Route exact path="/xivodafone/client/list" component={ClientList} />
                    <Route exact path="/xivodafone/query/list" component={QueryList} />
                    <Route exact path="/xivodafone/query/list/:companyId" component={QueryList} />
                    <Route exact path="/xivodafone/query/create" component={QueryCreate} />
                    <Route exact path="/xivodafone/query/create/:companyId" component={QueryCreate} />
                    <Route exact path="/xivodafone/query/edit/:id" component={QueryCreate} />
                    <Route exact path="/xivodafone/query/edit/:id/:companyId" component={QueryCreate} />
                    <Route exact path="/xivodafone/query/send/:id/:companyId" component={QuerySend} />
                    <Route exact path="/xivodafone/query/send-edit/:sendId" component={QuerySend} />
                    <Route exact path="/xivodafone/query/draft/:draftId" component={QuerySend} />
                    <Route exact path="/xivodafone/query/send/success" component={QuerySendSuccess} />
                    <Route exact path="/xivodafone/report" component={Report} />
                    <Route exact path="/xivodafone/partnerreport" component={PartnerReport} />
                    <Route exact path="/xivodafone/approve/list" component={SmsApproveList} />
                    <Route exact path="/xivodafone/draft/list" component={DraftList} />
                    <Footer />
                </Suspense>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        app: state.app 
    }
}

export default withRouter(connect(mapStateToProps)(XIVodafoneLayout))